import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createPostWithImages } from '../services/api';

const TITLE_MAX = 64;

function Dashboard() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: '',
    details: '',
    animal_type: 'horse',
    price: '',
    location: ''
  });
  const [files, setFiles] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFiles = (e) => {
    setFiles(Array.from(e.target.files || []));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const post = await createPostWithImages(formData, files);
      navigate(`/posts/${post.post_id}`);
    } catch (err) {
      console.error('Failed to create post:', err);
      setError('Failed to create listing. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const animalTypes = ['horse', 'sheep', 'goat', 'chicken', 'cattle', 'pig'];

  return (
    <div>
      <h1 className="mb-4">Create New Listing</h1>
      {error && <div className="alert alert-danger">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Title *</label>
          <input
            type="text"
            name="title"
            className="form-control"
            value={formData.title}
            onChange={handleChange}
            maxLength={TITLE_MAX}
            required
          />
          <div className="hl-title-counter text-end">
            {formData.title.length}/{TITLE_MAX}
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label">Details</label>
          <textarea
            name="details"
            className="form-control"
            rows="4"
            value={formData.details}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Animal Type *</label>
          <select
            name="animal_type"
            className="form-select"
            value={formData.animal_type}
            onChange={handleChange}
            required
          >
            {animalTypes.map((type) => (
              <option key={type} value={type}>
                {type.charAt(0).toUpperCase() + type.slice(1)}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label">Price (USD)</label>
          <input
            type="number"
            name="price"
            className="form-control"
            value={formData.price}
            onChange={handleChange}
            min="0"
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Location</label>
          <input
            type="text"
            name="location"
            className="form-control"
            value={formData.location}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Photos</label>
          <input
            type="file"
            className="form-control"
            accept="image/*"
            multiple
            onChange={handleFiles}
          />
          {files.length > 0 && (
            <div className="hl-title-counter mt-1">
              {files.length} photo{files.length > 1 ? 's' : ''} selected
            </div>
          )}
        </div>

        <button type="submit" className="btn btn-primary" disabled={submitting}>
          {submitting ? 'Publishing…' : 'Create Listing'}
        </button>
      </form>
    </div>
  );
}

export default Dashboard;
